import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const rmskincareAPI = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  timeout: 10000,
})

export default rmskincareAPI;
